import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PageURL } from 'src/app/pages/pages';
import { UserBasicInfo } from '../../services/user-basic.service';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
    selector: 'app-bottom-navigation',
    templateUrl: './bottom-navigation.component.html',
    styleUrls: ['./bottom-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BottomNavigationComponent implements OnInit, OnChanges {
  @Input() activeUrl: string;
  @Input() userInfo?: UserBasicInfo;
  @Input() cashbackApproved: boolean;
  @Output() activePage = new EventEmitter<string>();

  PageURL: typeof PageURL = PageURL;

  selectedTheme: string = 'light';
  activeSection: any = {
    cashback: false,
    accounts: false,
    payments: false,
    more: false,
    reports: false
  }
  accountsIcon = 'assets/images/footer/accounts.svg';
  paymentsIcon = 'assets/images/footer/payments.svg';
  cashbackIcon = `assets/icon/menu/wb-bicashback-active.svg`;
  reportsIcon = `assets/icon/menu/wb-bireports-active.svg`;
  viewMoreIcon = 'assets/images/footer/view-more.svg';

  constructor(
    public readonly router: Router,
    public readonly activeRoute: ActivatedRoute,
    private readonly translate: TranslateService,
    public readonly popoverController: PopoverController,
    private readonly theme: ThemeService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly destroyRef: DestroyRef,
  ) { }

  ngOnInit() {
    this.theme.getActiveTheme()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(val => {
        this.selectedTheme = val;
        this.refreshNavigationIcons();
        this.cdRef.markForCheck();
      });

    if (this.activeUrl) {
      this.setActiveUrl();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.activeUrl) {
      return;
    }

    if (((!this.activeUrl.includes('/accounts') && !this.activeUrl.includes('/view-more'))) && this.userInfo?.Verified == false) {
      this.userInfo.actions.forEach(action => {
        if (action.id == 'VerifyEmail') {
          this.router.navigate(['/accounts']);
          if (this.activeUrl == '/accounts' || this.activeUrl == '/') return;
          this.emailVerifyPopover(this.translate.instant(action.text), this.userInfo?.Email);
        }
      });
      return;
    } else if (changes['activeUrl'] && this.activeUrl) {
      this.setActiveUrl();
    }
  }
  
  async emailVerifyPopover(text:string, userEmail:any) {
    const { EmailVerifyPopoverComponent } = await import('../notifications/email-verify-popover/email-verify-popover.component');
    const popover = await this.popoverController.create({
      component: EmailVerifyPopoverComponent,
      componentProps: {
        text: text,
        userEmail: userEmail
      },
      cssClass: 'email-verify-popover'
    });
    return await popover.present();
  }

  setActiveUrl() {
    this.activeSection.cashback = this.activeUrl.includes('cashback');

    this.activeSection.accounts = (this.activeUrl == '/' || this.activeUrl.includes('dashboard')) && !this.activeUrl.includes('reports');

    this.activeSection.payments = (this.activeUrl.includes('payments') || this.activeUrl.includes('deposit-form-page')) && !this.activeUrl.includes('reports');

    this.activeSection.more = this.activeUrl.includes('view-more') || this.activeUrl.includes('upload');

    this.activeSection.reports = this.activeUrl.includes('reports');
    this.refreshNavigationIcons();
  }

  navigateToPage(url: string) {
    if (url !== 'Markets' && url !== 'Tools'){
      this.router.navigate([url]);
      this.activePage.emit(null);
    } else {
      this.activePage.emit(url);
    }
    
  }

  private refreshNavigationIcons(): void {
    const isLight = this.selectedTheme == 'light';
    const isCashbackActive = this.activeSection.cashback;
    const isAccountsActive = this.activeSection.accounts;
    const isPaymentsActive = this.activeSection.payments;
    const isReportsActive = this.activeSection.reports;
    const isMoreActive = this.activeSection.more;

    this.cashbackIcon = isCashbackActive
      ? 'assets/icon/menu/wb-bicashback-active.svg'
      : (isLight ? 'assets/icon/menu/wb-bicashback-inactive.svg' : 'assets/icon/menu/wb-bicashback-inactive-dark.svg');

    this.accountsIcon = isAccountsActive
      ? 'assets/icon/menu/wb-accounts-active.svg'
      : (isLight ? 'assets/icon/menu/wb-accounts-inactive.svg' : 'assets/icon/menu/wb-accounts-inactive-dark.svg');

    this.paymentsIcon = isPaymentsActive
      ? 'assets/icon/menu/wb-payments-active.svg'
      : (isLight ? 'assets/icon/menu/wb-payments-inactive.svg' : 'assets/icon/menu/wb-payments-inactive-dark.svg');

    this.reportsIcon = isReportsActive
      ? 'assets/icon/menu/wb-bireports-active.svg'
      : (isLight ? 'assets/icon/menu/wb-bireports-inactive.svg' : 'assets/icon/menu/wb-bireports-inactive-dark.svg');

    this.viewMoreIcon = isMoreActive
      ? 'assets/icon/menu/wb-viewmore-active.svg'
      : (isLight ? 'assets/icon/menu/wb-viewmore-inactive.svg' : 'assets/icon/menu/wb-viewmore-inactive-dark.svg');
  }
}
